var DevOps = "DevOps";
var Gaming = "게임";
var Migration = "마이그레이션";
var Other = "기타";
var useCase = {
	"Use case": "사용 사례",
	"AI & machine learning": "AI 및 기계 학습",
	"Batch processing": "일괄 처리",
	"Big data, analytics, & business intelligence": "빅 데이터, 분석 및 비즈니스 인텔리전스",
	"Business applications - Microsoft": "비즈니스 애플리케이션 - Microsoft",
	"Business applications - Oracle": "비즈니스 애플리케이션 - Oracle",
	"Business applications - Other": "비즈니스 애플리케이션 - 기타",
	"Business applications - SAP": "비즈니스 애플리케이션 - SAP",
	"Content delivery": "콘텐츠 전송",
	DevOps: DevOps,
	Gaming: Gaming,
	"Internet of things": "사물 인터넷(IoT)",
	"Learning & certification": "학습 및 자격증",
	"Media services": "미디어 서비스",
	Migration: Migration,
	"Mobile applications": "모바일 애플리케이션",
	Other: Other,
	"Storage & backup": "스토리지 및 백업",
	"Websites & web apps": "웹 사이트 및 웹 앱"
};

export { DevOps, Gaming, Migration, Other, useCase as default };
